import { humanize } from '@utils';
import { getMetricUnit, LESS_THAN_NUMBER } from '@utils/metrics';

export default (number: number, metric: string, metricUnit?: string) => {
  const unit: any = metricUnit !== undefined ? metricUnit : getMetricUnit({ metricKey: metric });

  // for very small numbers
  if (number && number < LESS_THAN_NUMBER) {
    return { humanizedNumber: '< 0.001', humanizedUnit: unit };
  }

  // humanize
  const humanizedValue = humanize(number, unit);

  let data = {
    humanizedNumber: humanizedValue,
    humanizedUnit: unit || '',
  };

  // split prefix unit if any
  try {
    if (isNaN(humanizedValue as any)) {
      // eslint-disable-next-line no-useless-escape
      const splitValue = humanizedValue?.toString().match(/([\d\.]+)|(\D+)/g);

      if (splitValue) {
        // For metrics with unit ms, output of humanize(number, unit) comes as <number> <unit>
        // instead of <number> if unit is sec. This results in final display value as <number> <unit> <unit>
        // None of the pre-defined Video, Ad or Eco metrics have this issue.
        const updatedUnit = ['secs', 'sec', 'ms', 'mins', 'min'].includes(splitValue[1].trim())
          ? splitValue[1]
          : `${splitValue[1] || ''} ${unit || ''}`;
        data = {
          humanizedNumber: splitValue[0] || humanizedValue,
          humanizedUnit: updatedUnit,
        };
      }
    }
  } catch (err) {
    // defaults to original humanized value
  }

  return data;
};
